export enum StockLogoMediaLibraryTab {
    Upload = "Upload",
    StockImages = "StockImages"
}
